import { SharedModule } from '../../../shared/shared.module';
import { StudentsForImpactListComponent } from './students-for-impact-list.component';
import { StudentsForImpactListResolver } from './students-for-impact-list.resolver';
import { StudentsForImpactValidateComponent } from '../students-for-impact-validate/students-for-impact-validate.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';
import { BsDatepickerModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    DataTableModule,
    BsDatepickerModule.forRoot()
  ],
  declarations: [StudentsForImpactListComponent, StudentsForImpactValidateComponent],
  exports: [StudentsForImpactListComponent],
  providers: [StudentsForImpactListResolver],
  entryComponents: [StudentsForImpactValidateComponent]
})
export class StudentsForImpactListModule { }